import React, { useState, useEffect } from "react";
import { useMediaQuery, Typography, Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useAppSelector, useAppDispatch } from "../../../redux/hooks";
import { getAbfStatusLogs } from "../../../redux/slices/abfStatusSlice";
import moment from "moment";

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
});

const AbfStatusControl = () => {
  const dispatch = useAppDispatch();
  const assetPlanId = useAppSelector(
    (state) => state.getAssetPlanId.assetPlanId
  );
  const budgetYear = useAppSelector((state) => state.summary?.dapData?.budgetYear);
  const investmentId = useAppSelector((state) => state.summary?.dapData?.investmentId);
  const { data: AbfStatusLogsData = [], loading, error } = useAppSelector((state) => state.abfStatus);

  useEffect(() => {
    if (investmentId && budgetYear) {
      dispatch(getAbfStatusLogs({ investmentId, budgetYear: Number(budgetYear) }));
    }
  }, [assetPlanId, dispatch, investmentId, budgetYear]);

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          border: "1px solid #ccc",
          padding: "10px",
          overflowY: "auto",
        }}
      >
        <Box sx={{ width: "95%" }}>
          <TableContainer >
            <Table aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell style={{fontWeight:900}} >Investment</TableCell>
                  <TableCell style={{fontWeight:900}}>Status</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {AbfStatusLogsData.map((row) => (
                  <TableRow
                    key={row.investmentId}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.investmentId}
                    </TableCell>
                    <TableCell>{row.status}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default AbfStatusControl;
